module.exports = __webpack_public_path__ + "dist/assets/img/B.0f1885b6.svg";